<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Günlük Not</b-card-title>
      <b-button
        :variant="formStatus ? 'flat-danger' : 'danger'"
        @click="toggleForm"
      >
        <FeatherIcon
          :icon="formStatus ? 'ChevronUpIcon' : 'ChevronDownIcon'"
        />
        Not Ekle
      </b-button>
    </b-card-header>
    <b-card-body v-if="formStatus">
      <validation-observer ref="serviceWorkRules">
        <work-date />
        <work-times />
        <select-workers />
        <notes-text />
        <upload-photos />
        <hr>
        <div>
          <b-button
            :disabled="submitStatus"
            variant="danger"
            @click="submitForm"
          >
            <FeatherIcon icon="SaveIcon" />
            Günlük Notları Kaydet
          </b-button>
        </div>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BButton, BCardBody,
} from 'bootstrap-vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import WorkTimes from '@/views/Services/View/ServiceWorkForm/WorkTimes.vue'
import WorkDate from '@/views/Services/View/ServiceWorkForm/WorkDate.vue'
import NotesText from '@/views/Services/View/ServiceWorkForm/NotesText.vue'
import SelectWorkers from '@/views/Services/View/ServiceWorkForm/SelectWorkers.vue'
import UploadPhotos from '@/views/Services/View/ServiceWorkForm/UploadPhotos.vue'

export default {
  name: 'ServiceWorkForm',
  components: {
    BCard,
    BButton,
    BCardHeader,
    BCardTitle,
    BCardBody,
    ValidationObserver,
    WorkTimes,
    WorkDate,
    NotesText,
    SelectWorkers,
    UploadPhotos,
  },
  props: {
    refreshWorks: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
      submitStatus: false,
      formStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['serviceWorks/dataItem']
    },
    saveData() {
      return this.$store.getters['serviceWorks/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.submitStatus = false
        this.formStatus = false
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    localize('tr')
  },
  methods: {
    toggleForm() {
      this.formStatus = !this.formStatus
    },
    submitForm() {
      this.$refs.serviceWorkRules.validate().then(success => {
        if (success) {
          if (this.photosCheck()) {
            this.submitStatus = true
            this.dataItem.id_services = this.$route.params.id
            this.$store.dispatch('serviceWorks/saveData', this.dataItem)
              .then(response => {
                if (response.status) {
                  this.refreshWorks()
                }
              })
          } else {
            this.showToast({
              title: 'Uyarı!',
              icon: 'XIcon',
              text: 'Lütfen en az 3 fotoğraf yükleyin.',
              variant: 'danger',
            })
          }
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    photosCheck() {
      return this.dataItem.photos.slice(0, 3).every(photo => photo.id)
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
